import React from 'react';
import { Modal, Col, Row, Container } from 'react-bootstrap';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import Button from 'react-bootstrap/Button';

const ModalConfirmation = ({ onClose, onConfirm, isOpen, id }) => {
  const handleSubmit = () => {
    onConfirm(id);
  };

  return (
    <>
      <ButtonToolbar>
        <Modal show={isOpen} onHide={onClose} aria-labelledby="example-modal-sizes-title-sm">
          <Modal.Header closeButton>
            <Modal.Title id="example-modal-sizes-title-sm">Скасувати запис</Modal.Title>
          </Modal.Header>
          <Modal.Body>Ви дійсно бажаєте відмінити цей запис на прийом?</Modal.Body>
          <Modal.Footer>
            <Container>
              <Row>
                <Col xs="6">
                  <Button onClick={onClose} variant="outline-primary"> 
                    Ні
                  </Button>
                </Col>
                <Col xs="6">
                  <Button onClick={handleSubmit} variant="primary">
                    Так, пiдтвердити
                  </Button>
                </Col>
              </Row>
            </Container>
          </Modal.Footer>
        </Modal>
      </ButtonToolbar>
      <style>{`
        .modal-content {
          padding: 20px 10px;
        }
        .modal-footer .row {
          width: 100%;
          margin: 0;
        }
        .modal-footer .row > [class*="col"] {
          padding: 0 5px;
        }
        .modal-footer .btn {
          width: 100%;
          height: auto;
          min-height: 42px;
          white-space: normal;
          line-height: 1.3;
          padding: 10px 8px;
        }
      `}</style>
    </>
  );
};

export default ModalConfirmation;
